module.exports = __webpack_public_path__ + "static/media/29EUNOG16.c9073106.jpg";